module.exports = __webpack_public_path__ + "static/media/p3preview.0fed6f45.png";